/**
 * Anoura — start at the top on refresh
 *
 * Horizon saves the scroll position into history.state on pagehide and
 * restores it on every pageshow (see scroll-container.js). That is great
 * for back/forward navigation but means a page refresh dumps the visitor
 * mid-page. This script detects a reload, strips the saved position so
 * Horizon's restore becomes a no-op, and pins the scroll container to the
 * top. Back/forward navigation is untouched.
 */
(function () {
  'use strict';

  var entries = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation') : [];
  var nav = entries && entries[0];
  if (!nav || nav.type !== 'reload') return;

  // Respect explicit anchors: a reload of /#some-section should still jump there.
  if (window.location.hash) return;

  // Strip the scroll position Horizon saved on pagehide.
  try {
    var state = typeof history.state === 'object' && history.state !== null ? history.state : {};
    if (state.scrollTop != null) {
      var next = {};
      for (var key in state) {
        if (key !== 'scrollTop') next[key] = state[key];
      }
      history.replaceState(next, '');
    }
  } catch (e) {
    /* replaceState can throw in sandboxed contexts — worst case the jump stays */
  }

  // Also disable the browser's native restoration for this load (mobile path).
  try {
    history.scrollRestoration = 'manual';
  } catch (e) {
    /* older browsers */
  }

  var toTop = function () {
    requestAnimationFrame(function () {
      var pageWrapper = document.querySelector('.page-wrapper');
      if (pageWrapper) pageWrapper.scrollTop = 0;
      var root = document.scrollingElement || document.documentElement;
      root.scrollTop = 0;
    });
  };

  window.addEventListener('pageshow', toTop, { once: true });
})();
